import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-569b2060"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "card-image"
}
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = { class: "first-line" }
const _hoisted_4 = {
  key: 0,
  class: "icon"
}
const _hoisted_5 = { class: "card-main-content" }
const _hoisted_6 = { class: "line-author-view-moderate-comment" }
const _hoisted_7 = {
  key: 1,
  class: "btn-view-moderate-comment"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "card-label"
}
const _hoisted_10 = { class: "card-text" }
const _hoisted_11 = { class: "icons-container" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "moderated-container--tag"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "card-details"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "undo-text" }, "- Undo", -1))
const _hoisted_17 = ["width", "height"]
const _hoisted_18 = { class: "other-lines" }
const _hoisted_19 = { class: "card-extra-details" }
const _hoisted_20 = {
  key: 0,
  class: "card-details"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "undo-text" }, "- Undo", -1))
const _hoisted_22 = ["width", "height"]
const _hoisted_23 = {
  key: 3,
  class: "double-card"
}
const _hoisted_24 = { class: "second-title" }
const _hoisted_25 = { class: "card-content" }
const _hoisted_26 = { class: "first-line" }
const _hoisted_27 = { class: "icon" }
const _hoisted_28 = { class: "card-main-content" }
const _hoisted_29 = { class: "card-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TextClamp = _resolveComponent("TextClamp")!
  const _component_EmojiReactions = _resolveComponent("EmojiReactions")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['feedback-base-card', _ctx.cardType]),
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewDetail && _ctx.viewDetail(...args)))
  }, [
    (_ctx.showStar || _ctx.showTitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['card-header', _ctx.getHighlightClass()])
        }, [
          (_ctx.showTitle)
            ? (_openBlock(), _createBlock(_component_Typography, {
                key: 0,
                variant: "overline",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                ], undefined, true),
                _: 3
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Typography, {
            variant: "overline",
            class: "right-title"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "rightTitle", {}, undefined, true)
            ], undefined, true),
            _: 3
          }),
          (_ctx.showStar && _ctx.hasNetworkConnection)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "star-container",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onToggleStarred && _ctx.onToggleStarred(...args)), ["stop"]))
              }, [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: _ctx.faStarOutline,
                  class: "star",
                  size: "lg"
                }, null, 8, ["icon"]),
                _createVNode(_Transition, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: _ctx.faStar,
                      class: _normalizeClass(['star solid', { show: _ctx.isStarred }]),
                      size: "lg"
                    }, null, 8, ["icon", "class"])
                  ], undefined, true),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "image", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$slots.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.author)
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 0,
                  variant: "overline",
                  class: "card-author"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.author), 1)
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isAdmin && _ctx.hasModeratedComment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", { src: _ctx.magicWand }, null, 8, _hoisted_8),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                  }, _toDisplayString(_ctx.viewCommentText), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.hasAiQuestion)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.firstAiQuestion.question_text), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.isAdmin && _ctx.hasModeratedComment)
              ? (_openBlock(), _createBlock(_Transition, {
                  key: 0,
                  name: "slide"
                }, {
                  default: _withCtx(() => [
                    (_ctx.showText)
                      ? (_openBlock(), _createBlock(_component_Typography, {
                          key: 0,
                          variant: "body2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextClamp, {
                              "is-html": "",
                              text: _ctx.cardText,
                              "max-lines": _ctx.detailedView ? 0 : 2,
                              "text-italic": _ctx.textItalic
                            }, null, 8, ["text", "max-lines", "text-italic"])
                          ], undefined, true),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_Typography, {
                  key: 1,
                  variant: "body2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TextClamp, {
                      "is-html": "",
                      text: _ctx.cardText,
                      "max-lines": _ctx.detailedView ? 0 : 2,
                      "text-italic": _ctx.textItalic,
                      class: "allow-text-select"
                    }, null, 8, ["text", "max-lines", "text-italic"])
                  ], undefined, true),
                  _: 1
                })),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.commentCount > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['comment-number', _ctx.commentCountClass])
                  }, _toDisplayString(_ctx.commentCount), 3))
                : _createCommentVNode("", true),
              (_ctx.$slots.extraIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _renderSlot(_ctx.$slots, "extraIcon", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.originalComment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("img", { src: _ctx.magicWand }, null, 8, _hoisted_14),
                _createTextVNode(" Moderated by NiceAI ")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hasExtraDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.timestamp)
                  ? (_openBlock(), _createBlock(_component_Typography, {
                      key: 0,
                      variant: "overline",
                      class: "timestamp"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getRelativeDate(_ctx.timestamp)), 1),
                        (_ctx.showUndo)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('undoChat')))
                            }, [
                              _hoisted_16,
                              (_openBlock(), _createElementBlock("svg", {
                                class: "countdown",
                                width: _ctx.circleSize,
                                height: _ctx.circleSize
                              }, [
                                _createElementVNode("circle", {
                                  class: "countdown-circle",
                                  cx: "50%",
                                  cy: "50%",
                                  r: "25%",
                                  style: _normalizeStyle(_ctx.circleStyle)
                                }, null, 4)
                              ], 8, _hoisted_17))
                            ]))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _renderSlot(_ctx.$slots, "extraDetails", {}, undefined, true)
        ]),
        (_ctx.hasExtraDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_ctx.timestamp)
                ? (_openBlock(), _createBlock(_component_Typography, {
                    key: 0,
                    variant: "overline",
                    class: "timestamp"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getRelativeDate(_ctx.timestamp)), 1),
                      (_ctx.showUndo)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('undoChat')))
                          }, [
                            _hoisted_21,
                            (_openBlock(), _createElementBlock("svg", {
                              class: "countdown",
                              width: _ctx.circleSize,
                              height: _ctx.circleSize
                            }, [
                              _createElementVNode("circle", {
                                class: "countdown-circle",
                                cx: "50%",
                                cy: "50%",
                                r: "25%",
                                style: _normalizeStyle(_ctx.circleStyle)
                              }, null, 4)
                            ], 8, _hoisted_22))
                          ]))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.emojiView && _ctx.hasNetworkConnection)
      ? (_openBlock(), _createBlock(_component_EmojiReactions, {
          key: 2,
          reactions: _ctx.emojiReactions,
          onOnReact: _ctx.onReact
        }, null, 8, ["reactions", "onOnReact"]))
      : _createCommentVNode("", true),
    (_ctx.doubleCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Typography, { variant: "overline" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "secondTitle", {}, undefined, true)
              ], undefined, true),
              _: 3
            }),
            _createVNode(_component_Typography, {
              variant: "overline",
              class: "right-title"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "secondRightTitle", {}, undefined, true)
              ], undefined, true),
              _: 3
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                (_ctx.$slots.secondIcon)
                  ? _renderSlot(_ctx.$slots, "secondIcon", { key: 0 }, undefined, true)
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_Typography, {
                  variant: "overline",
                  class: "card-author"
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "secondAuthor", {}, undefined, true)
                  ], undefined, true),
                  _: 3
                }),
                _createVNode(_component_Typography, {
                  variant: "body2",
                  class: "card-text"
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "secondText", {}, undefined, true)
                  ], undefined, true),
                  _: 3
                }),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Typography, {
                    variant: "overline",
                    class: "timestamp"
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "secondTimestamp", {}, undefined, true)
                    ], undefined, true),
                    _: 3
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}